import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

const CostHistoryDialog = ({ costHistoryDialog, setCostHistoryDialog, costHistoryLoading }) => {
  return (
    <Dialog open={!!costHistoryDialog} onOpenChange={v => { if (!v) setCostHistoryDialog(null); }}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <svg className="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            {costHistoryDialog?.design_code || 'Design'} — Cost Info
          </DialogTitle>
        </DialogHeader>
        {costHistoryLoading ? (
          <div className="flex items-center justify-center py-8"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div></div>
        ) : costHistoryDialog ? (
          <div className="space-y-4">
            {/* Vendor */}
            <div className="flex items-center gap-2 p-3 bg-gray-50 rounded-lg">
              <span className="text-xs text-gray-500 font-medium">Vendor:</span>
              <span className="font-bold text-gray-900">{costHistoryDialog.vendor_name || 'Not assigned'}</span>
            </div>

            {/* Current Cost */}
            {costHistoryDialog.current_cost && Object.keys(costHistoryDialog.current_cost).length > 0 && (
              <div className="p-3 bg-indigo-50 rounded-lg border border-indigo-100">
                <p className="text-xs font-semibold text-indigo-700 mb-2">Current Cost</p>
                <div className="space-y-1">
                  {Object.entries(costHistoryDialog.current_cost).map(([sizes, cost], i) => (
                    <div key={i} className="flex justify-between text-sm">
                      <span className="text-gray-700">{sizes}</span>
                      <span className="font-bold text-indigo-800">{'\u20B9'}{Number(cost).toLocaleString('en-IN')}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Cost History Table */}
            {costHistoryDialog.cost_history?.length > 0 ? (
              <div>
                <p className="text-xs font-semibold text-gray-600 mb-2">Cost History</p>
                <div className="overflow-x-auto border rounded-lg">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-gray-50 border-b">
                        <th className="px-3 py-2 text-left font-medium text-gray-600">Date</th>
                        <th className="px-3 py-2 text-left font-medium text-gray-600">Source</th>
                        <th className="px-3 py-2 text-left font-medium text-gray-600">Sizes</th>
                        <th className="px-3 py-2 text-right font-medium text-gray-600">Cost/pc</th>
                      </tr>
                    </thead>
                    <tbody>
                      {costHistoryDialog.cost_history.map((h, i) => (
                        <tr key={i} className={`border-b border-gray-100 ${i === costHistoryDialog.cost_history.length - 1 ? 'bg-indigo-50/50' : ''}`}>
                          <td className="px-3 py-2 text-xs font-mono">{h.date}</td>
                          <td className="px-3 py-2">
                            <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded ${h.source === 'PO' ? 'bg-amber-100 text-amber-700' : 'bg-emerald-100 text-emerald-700'}`} data-testid={`cost-source-${i}`}>
                              {h.source === 'PO' ? 'PO (ordered)' : 'PE (received)'}
                            </span>
                          </td>
                          <td className="px-3 py-2 text-xs">{h.sizes}</td>
                          <td className="px-3 py-2 text-right font-medium">{'\u20B9'}{Number(h.cost).toLocaleString('en-IN')}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="text-center py-4 text-gray-400 text-sm">No purchase orders or entries found for this design</div>
            )}
          </div>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default CostHistoryDialog;
